import { Reader, Writer } from "protobufjs/minimal";
import type {
  CategorySale,
  Category,
} from "../../aysa_api/models/category.types";
import {
  encodeTargetGroup,
  decodeTargetGroup,
} from "../../aysa_api/models/target_group";
import type { Long } from "protoc-gen-ts";

export const decodeCategorySale = (reader: Reader): CategorySale => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    default:
      return 0;
  }
};

export const encodeCategorySale = (
  writer: Writer,
  value: CategorySale
): Writer => {
  return writer.int32(value);
};

export const createBaseCategory = (): Category => {
  return {
    id: 0,
    name: "",
    path: "",
    targetGroup: 0,
    isHidden: false,
    isSale: 0,
    isLeafCategory: false,
    isRootCategory: false,
  };
};

export const decodeCategory = (reader: Reader, length: number): Category => {
  const end = reader.pos + length;
  const message = createBaseCategory();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;
      case 3:
        message.path = reader.string();

        break;
      case 4:
        message.targetGroup = decodeTargetGroup(reader);

        break;
      case 5:
        message.isHidden = reader.bool();

        break;
      case 6:
        message.isSale = decodeCategorySale(reader);

        break;
      case 7:
        message.isLeafCategory = reader.bool();

        break;
      case 8:
        message.isRootCategory = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCategory = (writer: Writer, message: Category): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);
  writer.uint32(26).string(message.path);
  encodeTargetGroup(writer.uint32(32), message.targetGroup);
  writer.uint32(40).bool(message.isHidden);
  encodeCategorySale(writer.uint32(48), message.isSale);
  writer.uint32(56).bool(message.isLeafCategory);
  writer.uint32(64).bool(message.isRootCategory);

  return writer;
};
